
import { defineComponent, onMounted } from "vue";
import HomeBanner from "@/components/HomeBanner.vue";
import HomeFooter from "@/components/HomeFooter.vue";
import { Home } from '@/lang/local/home';
import { mergeLocale } from "@/lang";

export default defineComponent({
  components: {
    HomeBanner,
    HomeFooter
  },
  setup() {
    mergeLocale(Home)
    onMounted(() => {
      debugger;
    })
    return {};
  },

});
